export default __webpack_public_path__ + "static/media/pic8.8aecb4bf.jpg";